$( document ).ready(function() {
  
   var swiper = new Swiper(".testimonialSlider", {     
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
    },
      breakpoints: {
        10: {
          slidesPerView: 1,
          spaceBetween: 20,
          slidesPerView: "auto",
          centeredSlides: true,          
          initialSlide: 1,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 17,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 17,
        },
      },
  });

  // Show the first tab by default
  $('.tabs-stage div').hide();
  $('.tabs-stage div:first').show();
  $('.tabs-nav li:first').addClass('tab-active');
  
  // Change tab class and display content
  $('.tabs-nav a').on('click', function(event){
    event.preventDefault();
    $('.tabs-nav li').removeClass('tab-active');
    $(this).parent().addClass('tab-active');
    $('.tabs-stage div').hide();
    $($(this).attr('href')).show();
  });


    // // START template -- collection [ COLLECTION ]
    // if (document.body.classList.contains("template-collection")) {
  
      
    //   $(document).on("click","facet-filters-form .mobile-facets__summary",function(e){
    //     e.preventDefault();
    //     $(this).parents(".mobile-facets__details").toggleClass("open").find(".mobile-facets__submenu").slideToggle();
    //     $(this).parents(".mobile-facets__details").siblings().removeClass("open").find(".mobile-facets__submenu").slideUp();
    //   });
     
     
    // }
    // // END template -- collection [ COLLECTION ]

  featuredCollectionSlider();

function featuredCollectionSlider() {

  var swiper = new Swiper(".featured-collection-slider", {    
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
    },
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,
          slidesPerView: "auto",
          centeredSlides: true,          
          initialSlide: 1,
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
  });
  
}

  if($(window).width() <= 750){
  
     function textIconSlider() {
  
      var swiper = new Swiper(".textIconSlider", {
        slidesPerView: 1,
        spaceBetween: 20,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: false,
        },
      });
    }
    textIconSlider(); 
 
    function logosSlider() {
      var swiper = new Swiper(".logosSlider", {
        spaceBetween: 0,
        centeredSlides: true,
        spaceBetween: 63,
        speed: 6000,
        autoplay: {
          delay: 0,
        },
        loop: true,
        slidesPerView:'auto',
        allowTouchMove: false,
        disableOnInteraction: true
      });
    }
    logosSlider();
  
    function iconTextSlider() {
      var swiper = new Swiper(".iconTextSlider", {
        slidesPerView: 2,
        spaceBetween: 20,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
    iconTextSlider();
    
 }

// faq tabs -- start JS
function faqTabs() {
  let tabsTitle = document.querySelectorAll("[data-faq_content]");
  tabsTitle.forEach(item => {
    item.addEventListener("click", () => {
      let tabsData = item.getAttribute('data-faq_content');
      let tabsButtons = document.querySelectorAll("[data-faq_content]");
      tabsButtons.forEach(b => {
        if(b.getAttribute('data-faq_content') == tabsData){
          if(b.classList.contains('is_open')){
            b.classList.remove("is_open");    
          }else{
            b.classList.add("is_open");
          }
        }else{
          b.classList.remove("is_open");
        }
      });
    }); // click event END
  });
}
  faqTabs();
  
$(document).on('click', '.faq-scroll-tab a', function(){
  $(".faq-scroll-tab a").removeClass('active');
  $(this).addClass('active');
})

// $('.faq-scroll-tab a:first').addClass("active_tab");
//   $('.faq-scroll-tab a').on('click',function (e) {
//     e.preventDefault();
//     $('.faq-scroll-tab a').removeClass("active_tab");
//     $(this).addClass("active_tab");
//     var target = this.hash;
//     var $target = $(target);
//     $('html, body').stop().animate({
//         'scrollTop': $target.offset().top - $(".header-wrapper").offset().top
//       }, 900, 'swing', function () {
//     });
//   });
// faq tabs -- end JS

// START template -- product [ PRODUCT ]
    if (document.body.classList.contains("template-product")) {
      initPDP_accordion();
    }
// END template -- product [ PRODUCT ]

function initPDP_accordion(){
  var pdpAccordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;
    var links = this.el.find('.js-acc-single-trigger');
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }
  // $(".accordion-single-item:first-of-type").addClass("open");
  pdpAccordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
      $this = $(this),
      $next = $this.next();
    $next.slideToggle();
    $this.parent().toggleClass('open');
    if (!e.data.multiple) {
      $el.find('.accordion-single-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var pdpAccordion1 = new pdpAccordion($('#pdp_accordion'), false);
}

// PASSWORD SHOW AND HIDE start

class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}
// <show-password>
//   <a href="javascript:void(0);"class="close-icon">text</a>
// </show-password>

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END

  function productSlideWithThums() {
    var swiper = new Swiper(".product-thums-slider", {
      loop: true,
      spaceBetween: 15,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    var swiper2 = new Swiper(".product-main-slider", {
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
       thumbs: {
        swiper: swiper,
      },
    });
    
  }   
  productSlideWithThums();

 var navigation = $(".faq-scroll-tab");    
navigation.on("click", "a", function (event) {
  event.preventDefault(); //prevents previous event
  $(".faq-scroll-tab a").removeClass("active")
  $(this).addClass("active");
  smoothScroll($(this.hash));
});

  $('#faq_head').change(function(){
      var selectedValue = $(this).val();
      smoothScroll($(selectedValue));
  });

  
function smoothScroll(target) {
  console.log(target);
  var header_hight = (document.querySelector('sticky-header').offsetHeight + 10) || 150;
    $("body,html").animate(
        {
            scrollTop: target.offset().top - header_hight
        },
        300
    );
}
});

//newsletter popup

var lastShownTime = localStorage.getItem('popupLastShownTime');
var currentTime = new Date().getTime();
var oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
console.log(!lastShownTime || (currentTime - lastShownTime) > oneDay);
if (!lastShownTime || (currentTime - lastShownTime) > oneDay) {
  $('#newsletter-popup').fadeIn();
    localStorage.setItem('popupLastShownTime', currentTime);
}
if(window.location.href.includes('customer_posted=true')){
   $('#newsletter-popup').fadeIn();

}
$('.close-popup').click(function() {
  $('#newsletter-popup').fadeOut();
  if(window.location.href.includes('customer_posted=true')){
     window.location.replace('/');
  }
});

$(window).click(function(event) {
  if ($(event.target).is('#newsletter-popup')) {
    $('#newsletter-popup').fadeOut();
  }
});

//newsletter popup end